import React, { useState, useEffect } from "react";
import Card from "../../../components/Card";
import { Row, Col, Button } from "react-bootstrap";

import { toast } from 'react-toastify';
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { API_NUMBER_EDIT } from "../../../service/url";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../utilities/constant";
import RenderNumberForm from "./_form_update";
import { useAuth, errorCheck } from '../auth/auth-utils';

function getApiUrl(url, id) {
  return url.replace(":id", id);
}

export default function NumbersEdit() {

  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [DID, setDID] = useState("");
  const [countryCodeId, setCountryCodeId] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [numberType,setNumberType] = useState("");
  const [category,setCategory] =useState("");
  const [currency,setCurrency] = useState("");
  const [cost,setCost] = useState("");
  const [operator,setOperator] = useState("");
  const [status,setStatus] = useState("");
  const [trunks,setTrunks] = useState("");
  const [numberRoutingType, setNumberRoutingType] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  useEffect(() => {
    const editApiUrl = getApiUrl(API_NUMBER_EDIT, id);
    getApiCall(editApiUrl, {}).then(onGetSuccess).catch(onError);
  }, [id]);

  function onGetSuccess(resp) {
    setDID(resp.actual_number || "");
    setStateCode(resp.state_code || "");
    setCountryCodeId(resp.country_code || "");
    setCost(resp.cost || "")
    setNumberType(resp.number_type || "");
    setCategory(resp.category || "");
    setCurrency(resp.currency || "");
    setOperator(resp.operator || "");
    setStatus(resp.status || "");
    setTrunks(resp.trunk_id || "");
    setNumberRoutingType(resp.number_routing_type || "");
  }
  

  function validateForm() {

    let valid = true;

    if (!countryCodeId) {
        valid = false;
        // setToastProps({ message: 'Country Code required', type: 'danger' });
            toast.error("Country Code required");
    }
    else if (!numberType) {
        valid = false;
        // setToastProps({ message: 'Number Type is required', type: 'danger' });
            toast.error("Number Type is required");
    } else if (numberType === 'DID' && !category) {
        valid = false;
        // setToastProps({ message: 'Category is required for DID', type: 'danger' });
            toast.error("Category is required for DID");
    } else if (!currency) {
        valid = false;
        // setToastProps({ message: 'Currency is required', type: 'danger' });
            toast.error("Currency is required");
    } else if (numberType === 'DID' && !trunks) {
        valid = false;
        // setToastProps({ message: 'Currency is required', type: 'danger' });
            toast.error("Trunk is required");
    }
    else if (!DID) {
       valid = false;
      //  setToastProps({ message: 'DID is required', type: 'danger' });
            toast.error("DID is required");
    } else if (!cost && (category !== "Free")) {
        valid = false;
        // setToastProps({ message: 'Cost is required', type: 'danger' });
            toast.error("Cost is required");
    } else if (!operator) {
        valid = false;
        // setToastProps({ message: 'Operator is required', type: 'danger' });
            toast.error("Operator is required");
    } else if (numberType === 'DID' && !stateCode) {
        valid = false;
        // setToastProps({ message: 'State Code is required for DID', type: 'danger' });
            toast.error("State Code is required for DID");
    } else if (!status) {
      valid = false;
      // setToastProps({ message: 'Status is required', type: 'danger' });
            toast.error("Status is required");
  } else if (!numberRoutingType) {
      valid = false;
      toast.error("Number Routing Type is required");
  }
    return valid;

}

  async function submitForm(e) {
    e.preventDefault();

    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    let params = {
      numberType: numberType,
      currency: currency,
      countryCode: countryCodeId,
      DID: DID,
      cost: category === 'Free' ? '0' : cost,
      operator: operator,
      status: status,
      number_routing_type: numberRoutingType,
    };

    if (numberType === 'DID') {
        params.category = category;
        params.stateCode = stateCode;
        params.trunk_id = trunks;
    } 

    const editApiUrl = getApiUrl(API_NUMBER_EDIT, id);
    postApiCall(editApiUrl, params)
      .then(onNumberUpdateSuccess)
      .catch(onError);
  }

  function onNumberUpdateSuccess(resp) {
    // setToastProps({ message: "Number updated successfully", type: "success" });
            toast.success("Number updated successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.NUMBERS.LIST}`);
    }, 1500);
  }

  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     setButtonDisable(false);
    //  setToastProps({message: JSON.stringify(err), type: 'danger'});
            toast.error(JSON.stringify(err));
   }
 }

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Update Number Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-number-info"></div>

                <form
                  onSubmit={async (e) => {
                    submitForm(e);
                  }}
                >
                  <RenderNumberForm
                    DID={DID}
                    setDID={setDID}
                    countryCodeId={countryCodeId}
                    setCountryCodeId={setCountryCodeId}
                    stateCode={stateCode}
                    setStateCode={setStateCode}
                    cost={cost}
                    setCost={setCost}
                    numberType={numberType}
                    setNumberType={setNumberType}
                    category={category}
                    setCategory={setCategory}
                    currency={currency}
                    setCurrency={setCurrency}
                    operator={operator}
                    setOperator={setOperator}
                    status={status}
                    setStatus={setStatus}
                    buttonDisable={buttonDisable}
                    setButtonDisable={setButtonDisable}
                    toastProps={toastProps}
                    setToastProps={setToastProps}
                    trunks={trunks}
                    setTrunks={setTrunks}
                    numberRoutingType={numberRoutingType}
                    setNumberRoutingType={setNumberRoutingType}
                  />

                  <Button
                    type={"submit"}
                    variant="btn btn-primary"
                    disabled={buttonDisable}
                  >
                    Update Number &nbsp;
                    {buttonDisable ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <></>
                    )}
                  </Button>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
}
